module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/_main-visual-text-e4379ebfc35cd11d2764b53cbf885957.svg";